// 方案組合計費種類（package.type）過濾用。
// - group_by_plan：訂閱
// - stored_value：席位方案（面額）
//
// 舊資料／AiSeatCreditPlansSeeder 曾把 AI 席位面額包寫成 group_by_plan，
// 特徵是非試用方案一律 validity_days === 0（儲值額度不綁約）。
// 用此特徵把誤標資料歸到席位，避免冒進訂閱分頁。

export const isSeatCreditShapedPackage = (pkg) => {
  const feePlans = (pkg?.plans || []).filter((p) => !p?.is_trial);
  if (!feePlans.length) return false;
  return feePlans.every((p) => Number(p?.validity_days) === 0);
};

export const getPackageBillingType = (pkg) => {
  if (pkg?.type === "stored_value") return "stored_value";
  // 誤標為訂閱、但結構是席位面額的舊資料
  if (isSeatCreditShapedPackage(pkg)) return "stored_value";
  if (pkg?.type === "group_by_plan") return "group_by_plan";
  // 其餘型別（如 grouped_by_limit）或無 type：兩邊都不顯示
  return null;
};

export const filterPackagesByBillingType = (packages, billingType) =>
  (packages || []).filter((pkg) => getPackageBillingType(pkg) === billingType);

/** 合併兩種 type 的 API 結果後再依計費種類過濾（跨桶撈出誤標資料）。 */
export const collectPackagesByBillingType = (byType, billingType) => {
  const primary = byType?.[billingType]?.packages || [];
  const otherKey =
    billingType === "stored_value" ? "group_by_plan" : "stored_value";
  const secondary = byType?.[otherKey]?.packages || [];
  const byId = new Map();
  [...primary, ...secondary].forEach((pkg) => {
    if (pkg?.id != null) byId.set(pkg.id, pkg);
  });
  return filterPackagesByBillingType([...byId.values()], billingType);
};
